var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid px-0"},[_c('div',{staticClass:"col-12 px-0"},_vm._l((_vm.components),function(component,index){return _c('BaseComponent',{key:index,attrs:{"componentData":component}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }